<template>
  <section class="report-page">
    <header class="report-header">
      <div><span class="eyebrow">Visão geral</span><h2>Desempenho da sua operação</h2><p>Acompanhe a evolução dos envios e da sua base de contatos.</p></div>
      <div class="report-filters">
        <ltk-date-picker label="Período analisado" v-model="filters.data.date" :loading="loading" />
        <button type="button" class="refresh-button" :disabled="loading" title="Atualizar dados" @click="forceRefreshData"><i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i><span>Atualizar</span></button>
      </div>
    </header>

    <div class="metrics-grid">
      <article class="metric-card metric-purple"><div class="metric-icon"><i class="far fa-paper-plane"></i></div><div><span>Envios realizados</span><strong>{{ calTotal(chartSEND.data.datasets) | number }}</strong><small>No período selecionado</small></div></article>
      <article class="metric-card metric-blue"><div class="metric-icon"><i class="far fa-address-book"></i></div><div><span>Novos contatos</span><strong>{{ calTotal(chartCONTACT.data.datasets) | number }}</strong><small>Crescimento da base</small></div></article>
      <article class="metric-card metric-orange"><div class="metric-icon"><i class="fas fa-user-minus"></i></div><div><span>Saídas da lista</span><strong>{{ calTotal(chartREMOVECONTACT.data.datasets) | number }}</strong><small>Descadastros no período</small></div></article>
    </div>

    <div v-if="loading" class="report-loading"><content-loading><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /><fake-line height="30" /></content-loading></div>

    <template v-else>
      <div class="charts-grid">
        <article class="chart-card">
          <header><div><span>Atividade</span><h3>Envios</h3></div><div class="chart-legend"><i></i> Total de envios</div></header>
          <line-chart v-if="chartSEND.data.datasets && chartSEND.data.datasets.length" :height="150" :chartData="chartSEND.data" :options="chartSEND.options" :limit="30" color="green" />
          <div v-else class="chart-empty">Sem dados de envio neste período.</div>
        </article>
        <article class="chart-card">
          <header><div><span>Audiência</span><h3>Novos contatos</h3></div><div class="chart-legend"><i></i> Contatos adicionados</div></header>
          <line-chart v-if="chartCONTACT.data.datasets && chartCONTACT.data.datasets.length" :height="150" :chartData="chartCONTACT.data" :options="chartCONTACT.options" :limit="30" color="green" />
          <div v-else class="chart-empty">Sem novos contatos neste período.</div>
        </article>
        <article class="chart-card chart-wide">
          <header><div><span>Retenção</span><h3>Saídas da lista</h3></div><div class="chart-legend warning"><i></i> Contatos removidos</div></header>
          <line-chart v-if="chartREMOVECONTACT.data.datasets && chartREMOVECONTACT.data.datasets.length" :height="125" :chartData="chartREMOVECONTACT.data" :options="chartREMOVECONTACT.options" :limit="30" color="green" />
          <div v-else class="chart-empty">Nenhuma saída registrada neste período.</div>
        </article>
      </div>

      <article class="activity-card">
        <header><div><span>Atividade recente</span><h3>Últimos envios</h3></div><span class="activity-count">{{ report.length }} registros</span></header>
        <ul v-if="report.length" class="activity-list">
          <li v-for="(item, index) in report" :key="index">
            <div class="recipient-icon">{{ item.email ? item.email.charAt(0).toUpperCase() : '?' }}</div>
            <div class="recipient"><strong>{{ item.email }}</strong><span>{{ item.send_name || 'Envio sem nome' }}</span></div>
            <span class="type-pill">{{ item.type }}</span>
            <time><i class="far fa-calendar"></i>{{ item.created_at | date }}</time>
          </li>
        </ul>
        <div v-else class="activity-empty"><i class="far fa-paper-plane"></i><p>Nenhum envio encontrado para o período selecionado.</p></div>
      </article>
    </template>
  </section>
</template>

<script>

import { getReport } from "@/services/report";

import lineChart from "@/components/charts/lineChart";
// import boxInfo from "@/components/boxInfo/BoxInfo";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  profit: "-",
  sales: "-",
  receita_bruta: "-",
  receita_liquida: "-",
  cost_product: "-",
  cost_marketing: "-",
  cost_tax_and_impost: "-",
  conv_billet: "-",
  avg_ticket: "-",
  percent_profit: "-",
  cpa: "-",
  roi: "-",
  approved_sales_count: "-",
  approved_sales_sum: "-",
  await_payment_sales_count: "-",
  await_payment_sales_sum: "-",
  sum_commission_dollar: "-",
  sum_dollar: "-",
};

export default {
  name: "report",
  components: {
    lineChart,
    ltkDatePicker,
    // boxInfo,
  },
  data() {
    return {
      loading: false,
      isTvMode: false,
      stats: emptyData,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      filters: {
        data: {
          date: [
            moment()
              .add(-7, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {

        },
      },
      chartSEND: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartCONTACT: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartREMOVECONTACT: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      report: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  watch: {
    "filters.data.date": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
      },
    },
  },
  mounted() {
    this.getReport()

    this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000)

  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  methods: {
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    calTotal(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'].reduce((t, n) => n + t , 0)
    },
    calMediaValue(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'].reduce((t, n) => n + t , 0) / data[index]['data'].length
    },
    lastValueDataset(data, index) {
      if (!data || data.length === 0) {
        return 0
      }

      if (!index) {
        index = 0
      }

      if (!data[index] || (data[index] && !data[index]['data'])) {
        return 0
      }

      return data[index]['data'][data[index]['data'].length - 1]
    },
    calDiffPercent(value1, value2) {
      if (!value1 || !value2) {
        return ''
      }

      let calDiff = value1 / value2
      calDiff = (calDiff - 1)  * 100
      calDiff = this.$options.filters.number(calDiff)

      if (value1 > value2) {
        return `<span style="color:green;">${calDiff}%</span>`
      }

      return `<span style="color:red;">${calDiff}%</span>`
    },
    getReport() {
      if (this.loading) {
        return
      }

      this.loading = true;

      const date = this.filters.data.date;
      
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      };

      getReport(params)
        .then((result) => {

          this.report = result.report;

          let auxDataset = [];

          // graph profit
          this.chartSEND.data.labels = result.chartSEND.labels;
          auxDataset = [];

          result.chartSEND.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartSEND.data.datasets = auxDataset;

          // graph profit ac
          this.chartCONTACT.data.labels = result.chartCONTACT.labels;
          auxDataset = [];

          result.chartCONTACT.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartCONTACT.data.datasets = auxDataset;

          // graph removed contact
          this.chartREMOVECONTACT.data.labels = result.chartREMOVECONTACT.labels;
          auxDataset = [];

          result.chartREMOVECONTACT.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });
          this.chartREMOVECONTACT.data.datasets = auxDataset;

        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
          this.data = emptyData;
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.report-page { width: 100%; }
.report-header { margin-bottom: 24px; display: flex; align-items: flex-end; justify-content: space-between; gap: 28px; }
.eyebrow { color: #7c3aed; font-size: 1.05rem; font-weight: 750; letter-spacing: .1em; text-transform: uppercase; }
.report-header h2 { margin: 5px 0; color: #171923; font-size: 2.5rem; line-height: 1.2; letter-spacing: -.025em; }
.report-header p { color: #667085; font-size: 1.3rem; }
.report-filters { display: flex; align-items: flex-end; gap: 10px; }
.refresh-button { min-height: 42px; padding: 0 14px; display: inline-flex; align-items: center; gap: 8px; border: 1px solid #ddd6ea; border-radius: 9px; color: #6d28d9; background: #fff; font-weight: 650; cursor: pointer; }
.refresh-button:hover:not(:disabled) { border-color: #8b5cf6; background: #faf8ff; }
.refresh-button:disabled { opacity: .6; cursor: wait; }
.metrics-grid { margin-bottom: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.metric-card { min-width: 0; padding: 20px; display: flex; align-items: center; border: 1px solid #e7e9f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 3px rgba(16,24,40,.03); }
.metric-icon { width: 48px; height: 48px; margin-right: 15px; flex: 0 0 auto; display: flex; align-items: center; justify-content: center; border-radius: 13px; font-size: 1.7rem; }
.metric-card > div:last-child { min-width: 0; display: flex; flex-direction: column; }
.metric-card span { color: #667085; font-size: 1.1rem; font-weight: 650; }
.metric-card strong { margin: 3px 0; color: #171923; font-size: 2.4rem; letter-spacing: -.03em; }
.metric-card small { color: #98a2b3; font-size: 1rem; }
.metric-purple .metric-icon { color: #7c3aed; background: #f2ecff; }
.metric-blue .metric-icon { color: #2563eb; background: #eff6ff; }
.metric-orange .metric-icon { color: #d97706; background: #fff7ed; }
.report-loading { padding: 26px; border: 1px solid #e7e9f0; border-radius: 14px; background: #fff; }
.charts-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.chart-card { min-width: 0; padding: 22px; border: 1px solid #e7e9f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 3px rgba(16,24,40,.03); }
.chart-wide { grid-column: 1 / -1; }
.chart-card header, .activity-card > header { margin-bottom: 22px; display: flex; align-items: center; justify-content: space-between; gap: 15px; }
.chart-card header span, .activity-card header div span { color: #98a2b3; font-size: 1rem; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }
.chart-card h3, .activity-card h3 { margin-top: 4px; color: #171923; font-size: 1.55rem; }
.chart-legend { color: #667085; font-size: 1.05rem; white-space: nowrap; }
.chart-legend i { width: 8px; height: 8px; margin-right: 6px; display: inline-block; border-radius: 50%; background: #7c3aed; }
.chart-legend.warning i { background: #f59e0b; }
.chart-empty { min-height: 180px; display: flex; align-items: center; justify-content: center; color: #98a2b3; font-size: 1.2rem; }
.activity-card { margin-top: 14px; padding: 22px; border: 1px solid #e7e9f0; border-radius: 14px; background: #fff; }
.activity-count { padding: 5px 9px; border-radius: 99px; color: #667085; background: #f2f4f7; font-size: 1rem; font-weight: 650; }
.activity-list { margin: 0; padding: 0; list-style: none; }
.activity-list li { padding: 13px 4px; display: grid; grid-template-columns: auto minmax(180px, 1fr) auto auto; align-items: center; gap: 14px; border-top: 1px solid #edf0f4; }
.recipient-icon { width: 38px; height: 38px; display: flex; align-items: center; justify-content: center; border-radius: 10px; color: #6d28d9; background: #f2ecff; font-weight: 750; }
.recipient { min-width: 0; display: flex; flex-direction: column; }
.recipient strong { overflow: hidden; color: #344054; font-size: 1.25rem; text-overflow: ellipsis; white-space: nowrap; }
.recipient span { margin-top: 3px; color: #98a2b3; font-size: 1.05rem; }
.type-pill { padding: 5px 9px; border-radius: 99px; color: #175cd3; background: #eff8ff; font-size: 1rem; font-weight: 650; }
.activity-list time { color: #667085; font-size: 1.1rem; white-space: nowrap; }
.activity-list time i { margin-right: 7px; color: #98a2b3; }
.activity-empty { padding: 44px 20px; color: #98a2b3; text-align: center; }
.activity-empty i { margin-bottom: 10px; font-size: 2.1rem; }

@media screen and (max-width: 900px) {
  .report-header { align-items: stretch; flex-direction: column; }
  .report-filters { justify-content: flex-end; }
  .metrics-grid { grid-template-columns: 1fr; }
  .charts-grid { grid-template-columns: 1fr; }
  .chart-wide { grid-column: auto; }
}
@media screen and (max-width: 640px) {
  .report-filters { align-items: stretch; flex-direction: column; }
  .refresh-button { justify-content: center; }
  .chart-card { padding: 17px; }
  .chart-card header { align-items: flex-start; flex-direction: column; }
  .activity-list li { grid-template-columns: auto 1fr; }
  .type-pill, .activity-list time { grid-column: 2; }
}
</style>
